import { useEffect } from "react";
import { toast } from "react-toastify";

const REASON_MESSAGES = {
  "captcha-failed":
    "Falha na verificação reCAPTCHA. Por favor, tente novamente.",
  "password-changed":
    "Palavra-passe alterada com sucesso! Pode agora fazer login.",
  "invalid-credentials":
    "O endereço de e-mail ou a palavra-passe são inválidos.",
  "locked-account":
    "A sua conta foi bloqueada. Aceda a /users/unlock/new para solicitar o desbloqueio.",
  "account-unlocked":
    "Conta desbloqueada com sucesso! Pode agora fazer login.",
  "unconfirmed-account":
    "A sua conta ainda não foi confirmada. Consulte, por favor, o seu e-mail.",
  "blank_email": "Por favor, introduza um endereço de e-mail.",
  "email_not_sent":
    "Não foi possível enviar o e-mail de recuperação. Por favor, tente novamente.",
  "email_not_allowed":
    "Este e-mail não está autorizado para registo na plataforma.",
  "email_already_taken": "Este endereço de e-mail já se encontra registado.",
  "registration_failed":
    "Não foi possível completar o registo. Por favor, tente novamente.",
  "update_failed":
    "Não foi possível atualizar a palavra-passe. Certifique-se que cumpre os requisitos de segurança.",
  "invalid-token":
    "O token de recuperação é inválido ou expirou. Por favor, solicite um novo.",
  "unknown":
    "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.",
};

const useDeviseFeedback = ({ successMessage } = {}) => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const status = params.get("status");
    const reason = params.get("reason");

    if (status === "success") {
      const message = (reason && REASON_MESSAGES[reason]) || successMessage || "Operação realizada com sucesso!";
      toast.success(message);
    } else if (status === "error") {
      const message = reason
        ? REASON_MESSAGES[reason] ||
          "Ocorreu um erro inesperado. Por favor, tente novamente."
        : "Ocorreu um erro inesperado. Por favor, tente novamente.";
      toast.error(message);
    }

    // Clean URL params to prevent re-showing on refresh
    if (status) {
      window.history.replaceState({}, "", window.location.pathname);
    }
  }, []);
};

export default useDeviseFeedback;
